'use client'

import { cn } from '@brew/ui/cn'
import type { IntegrationMeta } from '@/lib/integrations/catalog'
import { IntegrationBrandLogo } from './integration-brand-logo'

export type IntegrationLogoTileProps = {
  integration: Pick<
    IntegrationMeta,
    'id' | 'name' | 'logoTone' | 'logoBackground' | 'brandDomain'
  >
  /** Outer tile sizing/spacing. Defaults to a responsive `size-14 md:size-16`. */
  className?: string
}

/**
 * Bordered, rounded tile that frames an integration brand mark. Single
 * source of truth for the hero logo treatment shared by the in-app
 * integration detail `Hero` and the public marketing provider page —
 * so both surfaces render the logo identically (contained, padded, never
 * cropped) and any future restyle happens in one place.
 */
export function IntegrationLogoTile({
  integration,
  className,
}: IntegrationLogoTileProps) {
  return (
    <div
      className={cn(
        'flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-border bg-background md:size-16',
        className
      )}
    >
      <IntegrationBrandLogo
        variant="card"
        brandDomain={integration.brandDomain}
        provider={integration.id}
        name={integration.name}
        tone={integration.logoTone}
        background={integration.logoBackground}
        className="h-full w-full"
        imgClassName="h-full w-full rounded-lg object-contain p-2.5"
      />
    </div>
  )
}
